import { createSlice } from "@reduxjs/toolkit";

const eventIdSlice = createSlice({
  name: "eventId",
  initialState: {
    eventId: null,
  },
  reducers: {
    setEventId: (state, action) => {
      state.eventId = action.payload;
    },
    clearEventId: (state) => {
      state.eventId = null;
    },
  },
});

export const { setEventId, clearEventId } = eventIdSlice.actions;

export default eventIdSlice.reducer;
